import React, { Component } from 'react';
import './Policy.css';

import firebase from 'firebase';
import { compose } from 'recompose';
import { withAuthorization, withStorageSync, AuthUserContext } from '../../session/index';
import * as ROUTES from '../../constants/routes';

import { PolicyHeader, PolicyPage } from '../../static/templates/Policy';

import { updateUser } from '../../firebase/api/users';
import { getUserUid } from '../../static/localStorage';
import WithRouter from '../../helpers/WithRouter';

class AcceptDeclinePolicy extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dto: {
                uid: '',
                acceptPolicy: false,
            },
        };
    }

    onChoose = (accept, updateAuthUser) => {
        const dto = { ...this.state.dto };
        dto.uid = getUserUid();
        dto.acceptPolicy = accept;
        updateUser(dto)
            .then(res => {
                const { navigate, location } = this.props;
                updateAuthUser({ acceptPolicy: accept });
                if (!accept) {
                    navigate(ROUTES.SIGN_IN);
                    localStorage.removeItem('authUser');
                    firebase.auth().currentUser.delete();
                } else {
                    navigate(`${ROUTES.MY_ALL_POSTS}?welcome=true`);
                }
            })
            .catch(function (error) {
                console.log('policy:', error);
            });
    };

    render() {
        return (
            <AuthUserContext.Consumer>
                {({ updateAuthUser }) => (
                    <div className="Accept Policy">
                        <PolicyHeader />
                        <PolicyPage />
                        <div className="policy-button">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => this.onChoose(false, updateAuthUser)}
                            >
                                Decline
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.onChoose(true, updateAuthUser)}
                            >
                                Accept
                            </button>
                        </div>
                    </div>
                )}
            </AuthUserContext.Consumer>
        );
    }
}

const condition = authUser => !!authUser;

export default compose(
    withAuthorization(condition),
    WithRouter,
    withStorageSync
)(AcceptDeclinePolicy);
